import React from "react";
import Style from "./ConfirmModal.module.scss";

function ConfirmModal({
  isShowModal,
  onOk,
  onClose,
  title,
  caption,
  okText,
  closeText,
  showCancel = true,
  variant = "danger", // danger | primary
}) {
  if (!isShowModal) return null;

  return (
    <div
      className={Style.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className={Style.modal}>
        <div className={Style.body}>
          <div className={`${Style.iconWrapper} ${Style[variant]}`}>
            {variant === "success" ? (
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="m9 12 2 2 4-4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>

          {title && (
            <h3 id="modal-title" className={Style.title}>
              {title}
            </h3>
          )}

          {caption && <p className={Style.caption}>{caption}</p>}

          <div className={Style.actions}>
            {showCancel && (
              <button
                type="button"
                className={Style.cancelBtn}
                onClick={onClose}
              >
                {closeText || "Cancel"}
              </button>
            )}
            <button
              type="button"
              className={`${Style.confirmBtn} ${Style[variant]}`}
              onClick={() => {
                onOk();
              }}
            >
              {okText || "OK"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
